import LegalPage from './LegalPage';
import { useLanguage } from '../i18n/LanguageContext';

export default function Terms() {
  const { t } = useLanguage();
  return (
    <LegalPage
      testId="terms-page"
      backLabel={t.legal_back}
      eyebrow={t.tc_eyebrow}
      title={t.tc_h}
      titleAccent={t.tc_h_accent}
      effective={t.legal_effective}
      intro={t.tc_intro}
      sections={t.tc_sections}
      contactPre={t.legal_contact_pre}
      contactEmail={t.legal_email}
    />
  );
}
